import React from 'react';

import Logo from '@wetransfer/transfer/component/icon/logo';
import I18n from '@wetransfer/transfer/modules/i18n';
import { Button } from '@wetransfer/transfer/oneui/react';

import IconCheckmark from './IconCheckmark';
import styles from './VerifyMobile.module.scss';

export const DEEPLINK_URL = 'https://mobile.wetransfer.com/email-verified';

function VerifyMobile() {
  const onOpenInAppButtonClick = () => {
    window.open(DEEPLINK_URL);
  };

  return (
    <div className={styles.AppLayout}>
      <div className={styles.AppHeader}>
        <div className={styles.LogoContainer}>
          <Logo color="#484A4C" className={styles.Logo} />
        </div>
      </div>
      <div className={styles.CenterContainer}>
        <div className={styles.AppContent}>
          <IconCheckmark />
          <h2 className={styles.Title}>{I18n.t('mobile_verify.title')}</h2>
          <p className={styles.Subtitle}>{I18n.t('mobile_verify.subtitle')}</p>
          <div className={styles.ButtonContainer}>
            <Button variant="primary" onClick={onOpenInAppButtonClick}>
              {I18n.t('mobile_verify.cta')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyMobile;
